export var LogSeverity = /*#__PURE__*/ function(LogSeverity) {
    LogSeverity[LogSeverity["JL1"] = 0] = "JL1";
    LogSeverity[LogSeverity["JL2"] = 1] = "JL2";
    LogSeverity[LogSeverity["JL3"] = 2] = "JL3";
    LogSeverity[LogSeverity["JL4"] = 3] = "JL4";
    LogSeverity[LogSeverity["JL5"] = 4] = "JL5";
    return LogSeverity;
}({});
